import { __decorate } from "tslib";
import { Component, Model, Vue, Prop } from "vue-property-decorator";
let CounterButton = class CounterButton extends Vue {
    constructor() {
        super(...arguments);
        this.backgroundColor = "#feca38";
        this.textColor = "#000";
    }
    get colorsRules() {
        return `background-color: ${this.backgroundColor}; color: ${this.textColor};`;
    }
    minus() {
        if (this.value > 1 || this.toCero == true) {
            this.$emit("change", this.value - 1 < 0 ? 0 : this.value - 1);
        }
    }
    add() {
        if (this.value < 100) {
            this.$emit("change", this.value + 1);
        }
    }
    created() {
        const colors = this.$store.getters.colors;
        this.backgroundColor = colors.backgroundColor;
        this.textColor = colors.textColor;
    }
};
__decorate([
    Model("change", { type: Number, default: 1 })
], CounterButton.prototype, "value", void 0);
__decorate([
    Prop({ default: false })
], CounterButton.prototype, "toCero", void 0);
CounterButton = __decorate([
    Component
], CounterButton);
export default CounterButton;
